import {Input, Modal} from 'antd'
import React from 'react'
import {renderSelf} from 'views/Shared'
import {PiCheckCircle, PiQuestion, PiTrash} from "react-icons/pi";

export const createInputModal = ({
                                     modal,
                                     onOk,
                                     title,
                                     message,
                                     translate = (text) => text,
                                     placeholder = '',
                                     value,
                                     ...props
                                 }) => {
    let inputValue = '';

    (modal ?? Modal).confirm({
        icon: null,
        className: 'custom-modal text-base',
        title: (
            <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                {typeof title === "string" ? translate(title) : title}
            </div>
        ),
        content: (
            <div className="flex flex-col gap-1">
                <span className="uppercase text-sm font-semibold text-color-300 tracking-wide">
                    {typeof message === "string" ? translate(message) : message}
                </span>
                <Input.TextArea
                    rows={3}
                    defaultValue={value}
                    placeholder={translate(placeholder)}
                    onChange={(e) => {
                        inputValue = e.target.value;
                    }}
                />
            </div>
        ),
        okText: translate(value ? 'save' : 'add'),
        cancelText: translate('close'),
        okButtonProps: {
            size: 'small',
            type: 'primary',
            className: 'button-rounded-md no-border px-4 text-xs',
        },
        cancelButtonProps: {
            size: 'small',
            className: 'button-rounded-md no-border px-4 text-xs',
        },
        onOk: () => {
            if (onOk) onOk(inputValue);
        },
        ...props,
    });
};

const createConfirmDialog = ({
                                 modal,
                                 icon = <PiQuestion className="anticon"/>,
                                 onOk,
                                 title,
                                 message,
                                 translate = renderSelf,
                                 ...props
                             }) =>
    (modal ?? Modal).confirm({
        icon,
        className: 'custom-modal text-base',
        title: (
            <div className="font-bold text-orange-500 tracking-wider">
                {typeof title === "string" ? translate(title) : title}
            </div>
        ),
        content: (
            <div className="text-sm text-color-300 italic">
                {typeof message === "string" ? translate(message) : message}
            </div>
        ),
        onOk,
        ...props,
    })

export const createConfirmApproveDialog = ({
                                               modal,
                                               onOk,
                                               title,
                                               message,
                                               translate = renderSelf,
                                               ...props
                                           }) =>
    (modal ?? Modal).confirm({
        icon: <PiCheckCircle style={{color: '#38a169'}} className="anticon"/>,
        className: 'custom-modal text-base',
        title: (
            <div className="font-semibold text-green-600">
                {typeof title === "string" ? translate(title) : title}
            </div>
        ),
        content: (
            <div className="text-sm text-color-300 italic">
                {typeof message === "string" ? translate(message) : message}
            </div>
        ),
        onOk,
        ...props,
    })


export const showConfirmDialog = ({
                                      onOk,
                                      title = 'are you sure',
                                      message = 'are you sure to continue executing?',
                                      translate = renderSelf,
                                      okText = translate('sure'),
                                      cancelText = translate('cancel'),
                                      ...props
                                  }) =>
    createConfirmDialog({
        ...props,
        onOk,
        className: 'custom-modal text-base',
        title: typeof title === "string" ? translate(title) : title,
        message: typeof message === "string" ? translate(message) : message,
        okText: okText,
        cancelText: cancelText,
        okButtonProps: {
            type: 'text',
            className: 'rounded-lg no-shadow no-text-shadow no-border font-medium text-red-600',
        },
        cancelButtonProps: {
            color: 'primary', variant: 'solid',
            className: 'rounded-lg no-shadow no-text-shadow no-border',
        },
    })

export const showDeleteConfirmDialog = ({
                                            onOk,
                                            icon = <PiTrash className="anticon"/>,
                                            title = 'are you sure',
                                            message = 'are you sure you want to delete it permanently?',
                                            translate = renderSelf,
                                            ...props
                                        }) =>
    createConfirmDialog({
        ...props,
        onOk,
        className: 'custom-modal',
        title: translate(title),
        message: translate(message),
        okText: translate('sure'),
        cancelText: translate('ignore'),
        okButtonProps: {
            type: 'primary',
            danger: true,
            className: 'rounded-lg no-shadow no-text-shadow no-border',
        },
        cancelButtonProps: {
            className: 'rounded-lg no-shadow no-text-shadow no-border text-color-200',
        },
    })

export default createConfirmDialog
